import { IMediaPermissions } from '@gem/call/CallStore/Call.types';
import { CallProviderType, ICallInfo } from '@gem/call/Model/callModel.types';
import { IDevices } from '@gem/call/tasks/getDefaultDevices';
import { t } from '@gem/modules/i18n';

import Tasks from 'APP/Tasks';
import { callModel } from 'APP/model/model';
import Entities from 'STORE';
import { MainCall } from 'STORE/Calls/MainCall/MainCall';

const createExistingCall = async (
  providerType: CallProviderType,
  channelId: string
): Promise<ICallInfo | null> => {
  try {
    const response = await callModel.getCallInfo({
      channelId,
      providerType: providerType,
    });

    return response;
  } catch (e) {
    console.error(e);
    Tasks.app.showAlert(t('calls_connection_error'));
    return null;
  }
};

interface ICreateCallProps {
  groupId?: string;
  channelId: string;
  withAudio: boolean;
  withVideo: boolean;
  devicesIds: IDevices;
  isWaitingRoomEnabled?: boolean;
  isGuestsAllowed?: boolean;
  mediaPermissions?: IMediaPermissions;
}

export const joinToUnauthorizedCall = async ({
  groupId,
  channelId,
  withAudio,
  withVideo,
  devicesIds,
  isWaitingRoomEnabled,
  isGuestsAllowed,
  mediaPermissions,
}: ICreateCallProps): Promise<void> => {
  const callInfo = await createExistingCall(CallProviderType.Livekit, channelId);

  if (!callInfo) {
    return;
  }

  const me = callInfo.members.find((item) => item.providerUserUid === callInfo.audioVideoUid);

  if (!me) {
    return;
  }

  const mainCall = new MainCall({
    myId: me.userId,
    calls: Entities.Calls,
    groupId,
    channelId,
    providerType: Entities.Calls.callsProvider,
    withoutTimer: true,
    isUnauthorizedCall: true,
    initialMedia: {
      withAudio,
      withVideo,
    },
    initialDevicesIds: devicesIds,
    isWaitingRoomEnabled,
    isGuestsAllowed,
    mediaPermissions,
  });

  Entities.Calls.add(mainCall);

  Entities.usersStore.addMe({
    id: me.userId,
    avatarUrl: me.avatarUrl,
    userName: me.username,
  });

  mainCall.setReadyToStart({
    callInfo,
    isInitiator: callInfo.initiatorId === Entities.usersStore.Me.id,
  });
};
